export default (value) => {
  const originalValue = parseInt(value);
  if (isNaN(originalValue)) {
    return '0';
  }

  const sign = (originalValue < 0) ? '-' : '';
  const absValue = Math.abs(originalValue);
  return (absValue > 999) ? `${ sign }${ (absValue / 1000) }k` : originalValue.toString();
};
